import { css } from '@emotion/react'
import Skeleton from './Skeleton'
import { media } from '@dfds-ui/theme'

const TravelSearchOfferSkeleton = () => {
  return (
    <div
      css={css`
        display: flex;
        background-color: transparent;
        width: fit-content;
      `}
    >
      <div
        css={css`
          font-weight: 500;
          padding: 16px;
          position: relative;
          right: 0;

          ${media.lessThan('m')`
            left: 0;
          `}
          ${media.greaterThan('l')`
            display: none;
          `}
        `}
      >
        <Skeleton
          css={css`
            height: 38px;
            width: 142px;
            ${media.greaterThan('m')`
              height: 42px;
            `}
          `}
        />
      </div>
    </div>
  )
}

export default TravelSearchOfferSkeleton
